import { Fragment } from "react";
import PropTypes from "prop-types";
import { BackButton } from "app/pages/.shared/BackButton/BackButton";
import "./FaqFooter.scss";
import FaqContactContainer from "app/pages/Faq/FaqFooter/FaqContact/FaqContactContainer";

const FaqFooter = ({
	hideContactByPhone = false,
	hideContactByMail = false,
	fallbackRedirectUrl,
	hideContactUsSection = false,
}) => {
	return (
		<Fragment>
			{!hideContactUsSection && (
				<div className="faq-footer__contact">
					<FaqContactContainer
						hideContactByPhone={hideContactByPhone}
						hideContactByMail={hideContactByMail}
					/>
				</div>
			)}
			<footer className="faq-footer">
				<div className="faq-footer__container">
					<div className="faq-footer__back">
						<BackButton
							className="faq-footer__back-button"
							label={"faq.footer.back.to.label"}
							to={{
								pathname: fallbackRedirectUrl,
							}}
						/>
					</div>
				</div>
			</footer>
		</Fragment>
	);
};

FaqFooter.propTypes = {
	hideContactByPhone: PropTypes.bool,
	hideContactByMail: PropTypes.bool,
	fallbackRedirectUrl: PropTypes.string,
	hideContactUsSection: PropTypes.bool,
};

export default FaqFooter;
